import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Estado } from '../../models/tareas.model';

@Component({
    selector: 'status-sticker',
    imports:[
        CommonModule
    ],
    template: ` 
    <div
        class="flex items-center justify-center w-auto max-w-52 px-4 rounded-md h-[30px] text-sm font-bold text-nowrap"
        [ngStyle]="{
            'background-color': color1, 
            'color':color2

        }"
    >
        {{ estado | titlecase }}
    </div>
    `
})

export class StatusStickerComponent implements OnInit {
    @Input() estado: string
    @Input() color1: string
    @Input() color2: string
    constructor() { }

    ngOnInit() { }
}